import { Link } from 'react-router-dom';
import type { VideoItem } from '@/types/video';
import { typeNameMap } from '@/utils/videos';

interface VideoCardProps {
  video: VideoItem;
  showSynopsis?: boolean;
}

export default function VideoCard({ video, showSynopsis = false }: VideoCardProps) {
  return (
    <Link
      to={`/detail/${video.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-500/50 transition-colors"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={`${video.title} 高清封面`}
          title={`${video.title} ${typeNameMap[video.type]} 在线观看`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/85 via-background-950/10 to-transparent opacity-90" />

        <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-background-950 text-[11px] font-semibold">
          {video.quality}
        </span>
        <span className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-md bg-background-950/70 text-accent-300 text-[11px] font-semibold">
          <i className="ri-star-fill text-[10px]" />
          {video.rating.toFixed(1)}
        </span>

        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="w-12 h-12 rounded-full bg-primary-500/95 flex items-center justify-center text-background-950">
            <i className="ri-play-fill text-2xl" />
          </span>
        </div>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <p className="text-[11px] text-foreground-700">{video.status}</p>
        </div>
      </div>

      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-900 line-clamp-1 group-hover:text-primary-400 transition-colors">
          {video.title}
        </h3>
        <p className="mt-1 text-xs text-foreground-500">
          {video.year} · {typeNameMap[video.type]} · {video.region}
        </p>
        {showSynopsis && (
          <p className="mt-1.5 text-xs text-foreground-600 line-clamp-2 leading-relaxed">
            {video.synopsis}
          </p>
        )}
      </div>
    </Link>
  );
}